import React from 'react';
import { Tab, Tabs, TabList, TabPanel, resetIdCounter } from 'react-tabs';
import PropTypes from 'prop-types';
import Loader from 'react-loader';
import s from './CricketScorecardV2.scss';
import Batting from './Batting';
import Bowling from './Bowling';
import Overs from './Overs';
import FallOfWickets from './FallOfWickets';
import Substitutes from './Substitutes';
import MatchDetails from './MatchDetails';

class CricketScorecard_v2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loaded: false };
  }

  componentWillMount() {
    if (
      !this.props.data ||
      !this.props.data.event ||
      this.dataRefreshRequired()
    ) {
      this.state.loaded = false;
      this.props.loadDataFn();
    } else {
      this.setState({
        ...this.state,
        loaded: true,
      });
    }
    if (this.props.data && this.props.data.innings) {
      this.state.loaded = true;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data.innings) {
      this.state.loaded = true;
    }
  }

  dataRefreshRequired() {
    const last = this.props.data.timestamp || 0;
    const now = Date.now();
    const difference = now - last;

    if (difference > 30000) {
      return true;
    }
    return false;
  }

  counter = 0;

  render() {
    // reset id counter to match tab ids on server and client
    resetIdCounter();
    const { data, wrapperClass, noShowBallByBall } = this.props;

    const defaultTabIndex = data && data.innings ? data.innings.length - 1 : 0;

    function createInningsTab(inning, index) {
      return (
        <Tab key={index}>
          {inning.battingTeamSName}
          {data.matchType === 'Test' &&
            ` INN ${parseInt((inning.number - 1) / 2, 10) + 1}`}
        </Tab>
      );
    }
    const restructureInningsData = (inningData, batting) => {
      const key = batting ? 'batsman_id' : 'bowler_id';
      if (inningData && inningData.length > 0) {
        inningData.map((inning, index) => {
          const playerinid = inning.playerin_id;
          inningData.map((item, innerIndex) => {
            if (playerinid === item[key]) {
              const firstHalf = inningData.slice(0, index + 1);
              const ele = item;
              const secondHalf = inningData.slice(index + 1, innerIndex);
              inningData = firstHalf.concat(ele).concat(secondHalf);
            }
            return inningData;
          });
          return inningData;
        });
      }
      return inningData;
    };
    const createInningsTabPanel = (inning, index, tosswonby, substitutes) => (
      <TabPanel key={index}>
        <Batting
          batsmen={restructureInningsData(inning.batsmen, true)}
          equation={inning.equation}
          extras={inning.extras}
          isWapView={this.props.params && this.props.params.isWapView}
          tosswonby={tosswonby}
        />
        {inning.fows &&
          inning.fows[0] &&
          inning.fows[0].score && (
            <FallOfWickets
              data={inning.fows}
              isWapView={this.props.params && this.props.params.isWapView}
            />
          )}
        {!noShowBallByBall &&
          inning &&
          inning.ballByBall &&
          inning.ballByBall.length > 0 && (
            <Overs overs={inning.ballByBall} equation={inning.equation} />
          )}
        {inning &&
          inning.bowlers &&
          inning.bowlers.length > 0 && (
            <Bowling
              bowlers={restructureInningsData(inning.bowlers)}
              isWapView={this.props.params && this.props.params.isWapView}
            />
          )}
        {substitutes &&
          substitutes.length > 0 && (
            <Substitutes
              data={substitutes}
              isWapView={this.props.params && this.props.params.isWapView}
              battingTeamId={inning.battingTeamId}
            />
          )}
      </TabPanel>
    );
    return (
      <Loader loaded={this.state.loaded}>
        <div>
          <Tabs
            className={`${s.inner} ${s[wrapperClass]}`}
            defaultIndex={defaultTabIndex}
          >
            <TabList>
              {data &&
                data.innings &&
                data.innings.map((item, index) =>
                  createInningsTab(item, index),
                )}
            </TabList>
            {data &&
              data.innings &&
              data.innings.map((item, index) =>
                createInningsTabPanel(
                  item,
                  index,
                  data.tosswonby,
                  data.substitutes,
                ),
              )}
          </Tabs>
          {!noShowBallByBall &&
            data &&
            data.tosswonby && <MatchDetails match={data} />}
        </div>
      </Loader>
    );
  }
}

CricketScorecard_v2.propTypes = {
  data: PropTypes.shape({
    event: PropTypes.string,
    innings: PropTypes.arrayOf(PropTypes.shape({})),
    timestamp: PropTypes.number,
    tosswonby: PropTypes.string,
  }),
  noShowBallByBall: PropTypes.bool,
};

CricketScorecard_v2.defaultProps = {
  data: undefined,
  noShowBallByBall: false,
};

export default CricketScorecard_v2;
